import { prepareEventListenerParameters } from "@angular/compiler/src/render3/view/template";
import { AfterViewInit, Component, ComponentFactoryResolver, Input, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxDataGridComponent } from "devextreme-angular";
import CheckBox from "devextreme/ui/check_box";


@Component({
    selector: 'asignacionevaluaciontaller_padre',
    templateUrl: './asignacionevaluaciontaller_padre.component.html',
    styleUrls: ['./asignacionevaluaciontaller_padre.component.scss']
})

export class AsignacionEvaluacionTallerPadreComponent implements AfterViewInit{
    consulta!: boolean;
    @Input() identificador!: number;
    @Input() nivelid!: number;
    @Input() cicloid!: number;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() periodoevaluacionid!: number;


    DataMaterias: any[];
    selectedRows: any[];
    groupCheckboxModel: any = {};
    visualizador: boolean = false;
    talleres: any = {};
    talleresSeleccionados: {[key: string]: any} = {};
    allowSelection: { [key: string]: boolean } = {};


    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    collapsed = false;
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.DataMaterias = [];
        this.selectedRows = [];
    }

    ngAfterViewInit() {
      if(this.identificador == 2){
          this.visualizador = true;
      }
  }

  setTallerPadre(){
      this.appService.Post("planeacion/asignacionevaluacion/taller/tallerpadres",{"cicloid":this.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.DataMaterias = res.data;
              let talleresId = this.DataMaterias.map(item => item.tallerextracurricularid)
              .filter((value, index, self) => self.indexOf(value) === index);

              talleresId.forEach(taller =>{
                  let valor = taller.toString();
                  this.talleres[valor] = false;
                  this.talleresSeleccionados[valor] = null; // Inicializar los puestos como null
                  this.allowSelection[valor] = false; // No permitir selección inicialmente
              });

              this.SetTallerPorPadre();
          }
      })
  }

  SetTallerPorPadre(){
      this.appService.Post("planeacion/asignacionevaluacion/taller/tallerpadresbuscar",{
          "cicloid": this.cicloid,
          "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid,
          "periodoevaluacionid": this.periodoevaluacionid,
          "nivelid": this.nivelid
      }).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              // Asignar puestos guardados previamente
              for(let taller of res.data.talleres){
                  this.talleresSeleccionados[taller.tallerextracurricularid] = taller.puestoid;
                  this.allowSelection[taller.tallerextracurricularid] = true;
                  if(taller.puestoid) {
                      // Obtener todos los alumnos del taller
                      let alumnosDelTaller = this.DataMaterias.filter(x=>x.tallerextracurricularid == taller.tallerextracurricularid);

                      // Verificar si hay alumnos específicos seleccionados para este taller
                      let alumnosSeleccionados = res.data.alumnos.filter((a: any) =>
                          alumnosDelTaller.some(alumno => alumno.alumnoid === a.alumnoid && alumno.tallerextracurricularid === a.tallerextracurricularid)
                      );

                      // Si no hay alumnos específicos, seleccionar todos los alumnos del taller
                      if(alumnosSeleccionados.length === 0) {
                          alumnosSeleccionados = alumnosDelTaller;
                          this.talleres[taller.tallerextracurricularid] = true;
                      } else {
                          this.talleres[taller.tallerextracurricularid] = alumnosSeleccionados.length === alumnosDelTaller.length;
                      }

                      // Asignar puestoid y seleccionar alumnos
                      if(this.identificador == 1){
                          for(let alumno of alumnosSeleccionados){
                              let alumnoEncontrado = this.DataMaterias.find(x => x.alumnoid === alumno.alumnoid && x.tallerextracurricularid === alumno.tallerextracurricularid);
                              if(alumnoEncontrado) {
                                  alumnoEncontrado.puestoid = taller.puestoid;
                                  this.grid.instance.selectRows([alumnoEncontrado], true);
                              }
                          }
                      } else {
                          for(let alumno of alumnosSeleccionados){
                              let alumnoEncontrado = this.DataMaterias.find(x => x.alumnoid === alumno.alumnoid && x.tallerextracurricularid === alumno.tallerextracurricularid);
                              if(alumnoEncontrado) {
                                  alumnoEncontrado.activo = true;
                                  alumnoEncontrado.puestoid = taller.puestoid;
                              }
                          }
                      }
                  }
              }
          }
      })
  }

  Seleccionarguardado(e:any){
      for(let val of e){
          let alumno = this.DataMaterias.find(x=>x.alumnoid == val.alumnoid);
          if(alumno){
              // Verificar si el taller tiene un puesto seleccionado
              if(this.talleresSeleccionados[alumno.tallerextracurricularid]){
                  alumno.puestoid = this.talleresSeleccionados[alumno.tallerextracurricularid];

                  if(this.identificador == 1){
                      this.grid.instance.selectRows([alumno], true);
                  }else{
                      alumno.activo = true;
                  }
              }
          }
      }
  }

  onTalleresChanged(puestoId: any, cellInfo: any){
      const tallerExtracurricularId = cellInfo.value.toString();

      // Actualizar el estado de permitir selección
      this.allowSelection[tallerExtracurricularId] = !!puestoId;

      // Si se deselecciona un puesto, deseleccionar todos los alumnos del taller
      if(!puestoId) {
          this.talleres[tallerExtracurricularId] = false;

          // Deseleccionar filas del taller
          const alumnosTaller = this.DataMaterias.filter(x => x.tallerextracurricularid == tallerExtracurricularId);
          if(alumnosTaller.length > 0 && this.identificador == 1) {
              this.grid.instance.deselectRows(alumnosTaller);

              // Eliminar de selectedRows
              this.selectedRows = this.selectedRows.filter(row =>
                  !alumnosTaller.some(alumno => this.isSameRow(row, alumno))
              );
          }
      } else {
          // Asignar el puestoid a todos los alumnos del taller
          this.DataMaterias.forEach(alumno => {
              if(alumno.tallerextracurricularid == tallerExtracurricularId) {
                  alumno.puestoid = puestoId;
              }
          });

          // Si el checkbox del grupo está marcado, seleccionar todos los alumnos
          if(this.talleres[tallerExtracurricularId]) {
              const alumnosTaller = this.DataMaterias.filter(x => x.tallerextracurricularid == tallerExtracurricularId);
              if(alumnosTaller.length > 0 && this.identificador == 1) {
                  this.grid.instance.selectRows(alumnosTaller, true);
              }
          }
      }
  }

  // Verifica si dos filas son la misma
  isSameRow(row1: any, row2: any): boolean {
      return row1 && row2 && row1.alumnoid === row2.alumnoid;
  }

  onRowPrepared(e: any) {
      if(e.rowType === 'data') {
          // Verificar si este alumno tiene un taller con puesto seleccionado
          const tallerExtracurricularId = e.data.tallerextracurricularid.toString();
          const hasPuesto = !!this.talleresSeleccionados[tallerExtracurricularId];

          // Si no tiene puesto seleccionado, desactivar la selección
          if(!hasPuesto) {
              e.rowElement.classList.add('row-disabled');
          }
      }
  }

  // Manejar clic en la fila para validar selección
  onRowClick(e: any) {
      if(e.rowType === 'data') {
          const tallerExtracurricularId = e.data.tallerextracurricularid.toString();
          const hasPuesto = !!this.talleresSeleccionados[tallerExtracurricularId];

          // Si no hay puesto seleccionado y se intenta seleccionar la fila
          if(!hasPuesto && e.rowIndex >= 0) {
              // Prevenir selección
              e.event.preventDefault();
              this.mensajeService.Alerta(AlertaEnum.Warning, "Debe seleccionar un puesto para este taller antes de poder seleccionar alumnos.");
              return false;
          }
      }
      return true;
  }

  GetNombreTaller(id : any){
      return this.DataMaterias.find( (p: any) => p.tallerextracurricularid == id).taller;
  }

  contentReady(e: any) {
      if (!this.collapsed) {
          this.collapsed = true;
          e.component.expandRow(['EnviroCare']);
      }
  }

  setChildState(grid: any, items: any, value: any) {
      const tallerExtracurricularId = items.items ?
          items.items[0].tallerextracurricularid.toString() :
          items.collapsedItems[0].tallerextracurricularid.toString();

      // Verificar si hay un puesto seleccionado para este taller
      if(!this.talleresSeleccionados[tallerExtracurricularId]) {
          // Mantener el valor actual del checkbox usando timeout
          setTimeout(() => {
              this.talleres[tallerExtracurricularId] = !this.talleres[tallerExtracurricularId];
          }, 0);
          this.mensajeService.Alerta(AlertaEnum.Warning, "Debe seleccionar un puesto para este taller antes de poder seleccionar alumnos.");
          return;
      }

      let elementos = items.items ? items.items : items.collapsedItems;

      // Asignar el puestoid a todos los elementos si se van a seleccionar
      if(value) {
          elementos.forEach((elemento: any) => {
              elemento.puestoid = this.talleresSeleccionados[tallerExtracurricularId];
          });
          grid.selectRows(elementos, true);
      } else {
          grid.deselectRows(elementos);
      }
  }

  selectionChangedHandler(e: any) {
      // Validar que solo se seleccionen filas con puesto asignado
      if(e.currentSelectedRowKeys && e.currentSelectedRowKeys.length > 0) {
          const invalidSelections = e.currentSelectedRowKeys.filter((item: any) => {
              const tallerExtracurricularId = item.tallerextracurricularid.toString();
              return !this.talleresSeleccionados[tallerExtracurricularId];
          });
          console.log(invalidSelections);
          if(invalidSelections.length > 0) {
              // Deseleccionar filas que no deberían ser seleccionables
              this.grid.instance.deselectRows(invalidSelections);
              this.mensajeService.Alerta(AlertaEnum.Warning, "Debe seleccionar un puesto para este taller antes de poder seleccionar alumnos.");
              //return;
          }
      }

      // Manejar el estado de los checkboxes de grupo
      if(e.currentDeselectedRowKeys && e.currentDeselectedRowKeys.length > 0) {
          for(const item of e.currentDeselectedRowKeys) {
              const valor = item.tallerextracurricularid.toString();
              const filtro = this.DataMaterias.filter(x => x.tallerextracurricularid.toString() === valor);
              const filtroselect = e.selectedRowsData.filter((x: any) => x.tallerextracurricularid.toString() === valor);

              this.talleres[valor] = filtroselect.length === filtro.length;
          }

          // Si se deseleccionaron todas las filas
          if(e.selectedRowKeys.length === 0) {
              // Reiniciar estado de talleres
              Object.keys(this.talleres).forEach(key => {
                  this.talleres[key] = false;
              });
          }
      }

      if(e.currentSelectedRowKeys && e.currentSelectedRowKeys.length > 0) {
          // Obtener talleres únicos de las filas seleccionadas
          const talleresUnicos = [...new Set(e.currentSelectedRowKeys.map((item: any) => item.tallerextracurricularid.toString()))];
          // Procesar cada taller único
          for(const tallerId of talleresUnicos) {
              const filtro = this.DataMaterias.filter(x => x.tallerextracurricularid.toString() === tallerId);
              const filtroselect = e.selectedRowsData.filter((x: any) => x.tallerextracurricularid.toString() === tallerId);

              this.talleres[tallerId as string] = filtroselect.length === filtro.length;
          }

          // Si se seleccionaron todas las filas
          if(e.selectedRowKeys.length === this.DataMaterias.length) {
              // Marcar todos los talleres
              Object.keys(this.talleres).forEach(key => {
                  if(this.talleresSeleccionados[key]) {
                      this.talleres[key] = true;
                  }
              });
          }
      }
  }

  Guardar() {
          // Crear objeto para enviar los talleres con sus puestos seleccionados
          const talleresConPuestos:any = {};

          Object.keys(this.talleresSeleccionados).forEach(tallerId => {
              if(this.talleresSeleccionados[tallerId]) {
                  talleresConPuestos[tallerId] = this.talleresSeleccionados[tallerId];
              }
          });

          this.appService.Post("planeacion/asignacionevaluacion/taller/tallerpadresguardar", {
              "agrupacion": this.talleres,
              "talleresConPuestos": talleresConPuestos,
              "seleccionados": this.selectedRows,
              "periodoevaluacionid": this.periodoevaluacionid,
              "nivelid": this.nivelid,
              "cicloid": this.cicloid,
              "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid
          }).then(res => {
              if(res.status == RespuestaEstatusEnum.Success) {
                  this.mensajeService.Alerta(AlertaEnum.Success, res.message);
              }
          });
  }


}
